import NotBillableBusinessList from '@/components/NotBillableBusiness/NotBillableBusinessList'

let NotBillableBusinessRouter = [{
  path: '/not-billable-business',
  name: 'NotBillableBusinessList',
  component: NotBillableBusinessList,
  meta: {
    title: 'Affaires non facturables',
    requiresAuth: true,
    authorizations: ['not-billable-business_index', 'desktop_access']
  }
}]

export default NotBillableBusinessRouter



// WEBPACK FOOTER //
// ./src/components/NotBillableBusiness/router.js